import BreakfastFoodComponent from "../../../NonMVPComponents/Recipes/Breakfast/BreakfastFoodsComponent";
const BreakfastFoods = () => {
  return (
    <div>
      <BreakfastFoodComponent />
    </div>
  );
};

export default BreakfastFoods;
